import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  authLoading: false,
  username: null,
  lastLogin: null,
  corporate_all_types_dropdowns: null,
  applications: null,
  eligibleAccounts: null,
  applications_loading: false,
  eligible_accounts_loading: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthLoading: (state, action) => {
      state.authLoading = action.payload;
    },
    setUsername: (state, action) => {
      state.username = action.payload;
    },
    setLastLogin: (state, action) => {
      state.lastLogin = action.payload;
    },
    setCorporateAllTypesDropdowns: (state, action) => {
      state.corporate_all_types_dropdowns = action.payload;
    },
    setApplications: (state, action) => {
      state.applications = action.payload;
    },
    setEligibleAccounts: (state, action) => {
      state.eligibleAccounts = action.payload;
    },
    setApplicationsLoading: (state, action) => {
      state.applications_loading = action.payload;
    },
    setEligibleAccountsLoading: (state, action) => {
      state.eligible_accounts_loading = action.payload;
    },
  },
});

export const {
  setAuthLoading,
  setUsername,
  setLastLogin,
  setCorporateAllTypesDropdowns,
  setApplications,
  setEligibleAccounts,
  setEligibleAccountsLoading,
  setApplicationsLoading,
} = authSlice.actions;
export default authSlice.reducer;
